import {MULTIPLE_CHOICE_QUESTIONS, PROBLEM_SOLVING} from '../constants/PagesNumberConstant';

export function universalPagesValidation(fieldName) {
    return (value, allValues = {}) => {
        const {
            typeOfPaper = '',
            page = 0,
            slide = 0,
            problem = 0,
            visualPiece = 0,
            question = 0,
        } = allValues;

        const _page = fieldName === 'page' ? (value || 0) : (page || 0);
        const _slide = fieldName === 'slide' ? (value || 0) : (slide || 0);
        const _problem = fieldName === 'problem' ? (value || 0) : (problem || 0);
        const _visualPiece = fieldName === 'visualPiece' ? (value || 0) : (visualPiece || 0);
        const _question = fieldName === 'question' ? (value || 0) : (question || 0);

        if (typeOfPaper === PROBLEM_SOLVING) {
            if (_problem < 1 && _visualPiece < 1 && _page < 1) {
                return 'Add at least one problem, visual piece, or page.';
            }
        } else if (typeOfPaper === MULTIPLE_CHOICE_QUESTIONS) {
            if (_question < 1) {
                return 'Add at least one question.';
            }
        } else {
            if (_problem < 1 && _visualPiece < 1 && _page < 1 && _slide < 1) {
                return 'Add at least one page, visual piece, slide, or problem.';
            }
        }

        return undefined;
    }
}

